import { render } from "./VerAlmacenes.vue?vue&type=template&id=20811695"
import script from "./VerAlmacenes.vue?vue&type=script&lang=js"
export * from "./VerAlmacenes.vue?vue&type=script&lang=js"

import "./VerAlmacenes.vue?vue&type=style&index=0&id=20811695&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__